/* Medi DermaBiome — global interactions */
(function () {
  'use strict';

  function updateCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  function showToast(msg, isError) {
    var t = document.querySelector('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.toggle('toast--error', !!isError);
    t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('is-visible'); }, 2500);
  }

  function bindAddToCart(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[name="add"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.data.description || 'Could not add to cart'); }
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          showToast('Added to cart');
        })
        .catch(function (err) { showToast(err.message || 'Something went wrong', true); })
        .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
    });
  }

  function animateStats(root) {
    root.querySelectorAll('.stat').forEach(function (s) { s.classList.add('is-visible'); });
    root.querySelectorAll('.stat__num').forEach(function (el) {
      var m = el.textContent.trim().match(/^(\D*)(\d[\d,]*)(.*)$/);
      if (!m) { return; }
      var prefix = m[1], target = parseInt(m[2].replace(/,/g, ''), 10), suffix = m[3];
      var duration = 1300, startTime = null;
      function step(ts) {
        if (!startTime) { startTime = ts; }
        var p = Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
        el.textContent = prefix + Math.floor(eased * target) + suffix;
        if (p < 1) { requestAnimationFrame(step); } else { el.textContent = prefix + target + suffix; }
      }
      requestAnimationFrame(step);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // AJAX add-to-cart on the product form
    var productForm = document.getElementById('product-form');
    if (productForm) { bindAddToCart(productForm); }

    // Register popup (first-visit, 10% off)
    var popup = document.getElementById('register-popup');
    if (popup) {
      var POPUP_KEY = 'medi_popup_dismissed';
      var openPopup = function () { popup.classList.add('is-open'); };
      var dismissPopup = function () {
        popup.classList.remove('is-open');
        try { localStorage.setItem(POPUP_KEY, String(Date.now())); } catch (e) {}
      };

      var days = parseInt(popup.dataset.days, 10);
      if (isNaN(days)) { days = 7; }
      var last = 0;
      try { last = parseInt(localStorage.getItem(POPUP_KEY) || '0', 10); } catch (e) {}
      var elapsedOk = days === 0 || (Date.now() - last) > days * 86400000;

      if (elapsedOk) {
        var delay = (parseInt(popup.dataset.delay, 10) || 3) * 1000;
        setTimeout(openPopup, delay);
      }

      popup.querySelector('.popup__close').addEventListener('click', dismissPopup);
      popup.addEventListener('click', function (e) { if (e.target === popup) { dismissPopup(); } });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && popup.classList.contains('is-open')) { dismissPopup(); } });

      var pForm = popup.querySelector('.popup__form');
      var pSuccess = popup.querySelector('.popup__success');
      if (pForm) {
        pForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = pForm.querySelector('button[type="submit"]');
          if (btn) { btn.disabled = true; btn.textContent = 'Submitting…'; }
          fetch(pForm.action, { method: 'POST', body: new FormData(pForm), headers: { 'Accept': 'text/html' }, redirect: 'follow' })
            .then(function () {
              pForm.style.display = 'none';
              if (pSuccess) { pSuccess.hidden = false; }
              try { localStorage.setItem(POPUP_KEY, String(Date.now())); } catch (e) {}
            })
            .catch(function () { if (btn) { btn.disabled = false; btn.textContent = 'Sign up & get 10% off'; } });
        });
      }
    }

    // Testimonials horizontal scroll arrows
    document.querySelectorAll('.testimonials__wrap').forEach(function (wrap) {
      var row = wrap.querySelector('.testimonials__row');
      if (!row) { return; }
      wrap.querySelectorAll('[data-scroll]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.dataset.scroll, 10) || 1;
          row.scrollBy({ left: dir * 340, behavior: 'smooth' });
        });
      });
    });

    // Generic horizontal scrollers (cards / gallery with > 3 items)
    document.querySelectorAll('.hscroll').forEach(function (wrap) {
      var row = wrap.querySelector('[data-hscroll-row]');
      if (!row) { return; }
      wrap.querySelectorAll('[data-scroll]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.dataset.scroll, 10) || 1;
          var step = row.firstElementChild ? row.firstElementChild.offsetWidth + 24 : 340;
          row.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
      });
    });

    // CEO "Our Values / Certifications / Science" tabbed panel
    document.querySelectorAll('[data-ceo-tabs]').forEach(function (panel) {
      var titleEl = panel.querySelector('[data-active-title]');
      var textEl = panel.querySelector('[data-active-text]');
      panel.querySelectorAll('.ceo-values__tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          if (titleEl) { titleEl.textContent = tab.dataset.title; }
          if (textEl) { textEl.textContent = tab.dataset.text; }
          panel.querySelectorAll('.ceo-values__tab').forEach(function (t) { t.classList.remove('is-active'); });
          tab.classList.add('is-active');
        });
      });
    });

    // Animated, scroll-revealed stats
    var statsSection = document.querySelector('.stats');
    if (statsSection) {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduceMotion && 'IntersectionObserver' in window) {
        statsSection.classList.add('will-animate');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { animateStats(statsSection); io.disconnect(); }
          });
        }, { threshold: 0.25 });
        io.observe(statsSection);
      }
    }

    // Mobile side drawer
    var toggle = document.querySelector('.header__toggle');
    var drawer = document.getElementById('mobile-drawer');
    var drawerOverlay = document.querySelector('[data-drawer-overlay]');
    if (toggle && drawer) {
      var openDrawer = function () {
        drawer.classList.add('is-open');
        if (drawerOverlay) { drawerOverlay.hidden = false; drawerOverlay.classList.add('is-open'); }
        drawer.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      };
      var closeDrawer = function () {
        drawer.classList.remove('is-open');
        if (drawerOverlay) { drawerOverlay.classList.remove('is-open'); }
        drawer.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      };
      toggle.addEventListener('click', openDrawer);
      var closeBtn = drawer.querySelector('.drawer__close');
      if (closeBtn) { closeBtn.addEventListener('click', closeDrawer); }
      if (drawerOverlay) { drawerOverlay.addEventListener('click', closeDrawer); }
      drawer.querySelectorAll('.drawer__nav a').forEach(function (a) { a.addEventListener('click', closeDrawer); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) { closeDrawer(); } });
    }

    // Accordions (FAQ / About values)
    document.querySelectorAll('.accordion__head').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.accordion__item');
        if (!item) return;
        var open = item.classList.contains('is-open');
        // close siblings within the same accordion
        var parent = item.parentElement;
        parent.querySelectorAll('.accordion__item').forEach(function (i) { i.classList.remove('is-open'); });
        if (!open) item.classList.add('is-open');
        head.setAttribute('aria-expanded', !open);
      });
    });

    // Product gallery thumbnail switching
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-main-image]');
      gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.src = thumb.dataset.full || thumb.src;
          gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  });
})();
